export default __webpack_public_path__ + "static/media/tablecloth.dc426d6e.svg";